import React, { useState } from "react";
import { LuChevronDown } from "react-icons/lu";
import Accordion from "./accordion";

const AccordionGroup = ({ header, items }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [loadingStates, setLoadingStates] = useState({});

  return (
    <div>
      <button
        type="button"
        aria-expanded={isOpen}
        className="tw-mt-2 tw-flex tw-min-h-11 tw-w-full tw-cursor-pointer tw-items-center tw-justify-between tw-rounded-r-md tw-border-x-0 tw-border-t-0 tw-border-b-0 tw-border-l-2 tw-border-solid tw-border-dis-deep-blue tw-bg-dis-sky-tint tw-px-3 tw-text-left tw-text-base tw-font-semibold tw-text-dis-navy hover:tw-bg-dis-info-hover"
        onClick={() => setIsOpen(!isOpen)}
      >
        {header}
        <LuChevronDown
          aria-hidden="true"
          className={`tw-h-5 tw-w-5 tw-shrink-0 tw-text-dis-deep-blue tw-transition-transform tw-duration-200 ${isOpen ? "tw-rotate-180" : ""}`}
        />
      </button>

      {isOpen && (
        <div>
          {items.map((item) => (
            <Accordion
              key={item.archiveId}
              title={item.templateItemDescription || item.archiveItemDescription}
              link={item.templateDocumentGetUrl || item.archiveDocumentGetUrl}
              linkDescription={item.templateExplanation || item.archivePackExplanation}
              isLoading={loadingStates[item.archiveId] || false}
              setLoading={(isLoading) =>
                setLoadingStates((prev) => ({
                  ...prev,
                  [item.archiveId]: isLoading,
                }))
              }
              name={item.webDownloadFileName}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default AccordionGroup;
